import { MatSnackBar } from '@angular/material/snack-bar';
import { LoginService } from './../../services/login-service.service';
import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {FormControl, Validators} from '@angular/forms';
import { texts, avaibleLanguages } from './../.././../environments/languages';
import { AngularFireAuth } from '@angular/fire/auth';
import { GlobalsService } from '../../globals.service';

@Component({
  selector: 'app-change-password-dialog',
  templateUrl: './change-password-dialog.component.html',
  styleUrls: ['./change-password-dialog.component.css']
})
export class ChangePasswordDialogComponent implements OnInit {

  FormControl
  password:string
  email:string
  hide = true
  newhide = true
  isUnderMinLength = false
  rememberMe = true
  language
  translte = texts
  loading = false
  NewEmail:string
  NewPassword:string
  emailFormControl = new FormControl('', [
    Validators.required,
    Validators.email,
  ]);

  passwordFormControl = new FormControl('', [
    Validators.required,
    Validators.minLength(6)
  ]);
  newPasswordFormControl = new FormControl('', [
    Validators.required,
    Validators.minLength(6)
  ]);
  buttonDisable = true
  constructor(private global:GlobalsService,private auth: AngularFireAuth,private snackBar:MatSnackBar,private LoginService:LoginService,public dialogRef: MatDialogRef<ChangePasswordDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data:any) {
      this.language =global.language
     }

  ngOnInit(): void {
  }
  getEmail(val){
    this.email = val
    if(!this.emailFormControl.hasError('email') && !this.emailFormControl.hasError('required') && !this.passwordFormControl.hasError('required')  && !this.passwordFormControl.hasError('minLength') && this.newPasswordFormControl.hasError('minLength') && !this.newPasswordFormControl.hasError('required') ){
      this.buttonDisable = false
    }
    else{
      this.buttonDisable = true
    }
  }
  getNewPasssword(val){
    this.NewPassword = val
    if(!this.emailFormControl.hasError('email') && !this.emailFormControl.hasError('required') && !this.passwordFormControl.hasError('required')  && !this.passwordFormControl.hasError('minLength') && this.newPasswordFormControl.hasError('minLength') && !this.newPasswordFormControl.hasError('required')){
      this.buttonDisable = false
    }
    else{
      this.buttonDisable = true
    }
  }
  getPassword(val){
    this.password = val
    if(!this.emailFormControl.hasError('email') && !this.emailFormControl.hasError('required') && !this.passwordFormControl.hasError('required') && !this.passwordFormControl.hasError('minLength') && this.newPasswordFormControl.hasError('minLength') && !this.newPasswordFormControl.hasError('required')){
      this.buttonDisable = false
    }
    else{
      this.buttonDisable = true
    }
  }
  onNoClick(): void {
    this.dialogRef.close();
  }
  loginPressed(){
    var success
    this.loading = true
    this.LoginService.tryToLogin(this.email, this.password).subscribe(
      res => {
        if(res){
          this.auth.authState.subscribe( user => {
            if (user) {     
               user.updatePassword(this.NewPassword).then(()=>{
                this.snackBar.open("Password updated successfully", "", {
                  duration: 2000,
                });  
               }).catch(err=>{this.snackBar.open("Cant update password, try again later "+ err, "", {
                              duration: 2000,
                             });  
              }).finally(()=>{this.onNoClick()})

            }
          });
        }
        else{
          this.loading = false
          this.snackBar.open("Inccorect email or password", "", {
            duration: 2000,
          });  
        }
      }, 
      error => { }
    );
  }
}
